import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error('ErrorBoundary caught an error', error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-[#050914] px-4 text-slate-100">
          <div className="max-w-md rounded-2xl border border-white/10 bg-white/[0.04] p-6 text-center shadow-2xl shadow-black/30">
            <div className="text-sm font-bold text-white">Vision could not load this workspace.</div>
            <div className="mt-2 text-sm leading-6 text-slate-400">Refresh the page. If it happens again, sign out and back in so the workspace can rebuild its session.</div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
